module.exports = __webpack_public_path__ + "static/media/Internationalcase1.4805f076.png";